import React from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { formatDateTime } from 'common/usual'
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core'
import EditBtn from 'components/EditBtn'

const MealIngredientCategoryTable = props => {
  const { data } = props

  return (
    <Card>
      <CardContent className={'table-content'}>
        <PerfectScrollbar>
          <div className={'inner'}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Title</TableCell>
                  <TableCell>Sort</TableCell>
                  <TableCell>Active</TableCell>
                  <TableCell>Created At</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {data && data.map(category => (
                  <TableRow className={'table-row'} key={category.id} hover>
                    <TableCell>{category.id}</TableCell>
                    <TableCell>{category.title}</TableCell>
                    <TableCell>{category.sort}</TableCell>
                    <TableCell>{category.active ? 'TRUE' : 'FALSE'}</TableCell>
                    <TableCell>{formatDateTime(category.createdAt)}</TableCell>
                    <TableCell>
                      <EditBtn history={props.history} path={`/meal-ingredient/category/edit/${category.id}`} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
    </Card>
  )
}

export default MealIngredientCategoryTable